import { FormInput, FormDropDown } from '../../forms/final-form-fields'
import { defineMessages } from 'react-intl'

const messages = defineMessages({
  pickupPoint: {
    id: 'pickupPoint',
    defaultMessage: 'Hotel name & address or pickup point',
  },
  dietaryRequirements: {
    id: 'dietaryRequirements',
    defaultMessage: 'Dietary requirements (if any)',
  },
  otherRequirements: {
    id: 'otherRequirements',
    defaultMessage: 'Other requirements (if any)',
  },
})

function AdditionalInfo({ activity, includedTransfer, includedFood }) {
  return (
    <div className='dive-experience-form mbh'>
      {includedTransfer && (
        <div className='form-row'>
          {activity.pickupPoints && activity.pickupPoints.length ? (
            <FormDropDown
              name={`trips[0].additionalRequirements.userPickupPoint.pickupPointId`}
              title={messages.pickupPoint}
              isRequired
              optionLabelKey='address'
              options={activity.pickupPoints}
            />
          ) : (
            <FormInput
              name={`trips[0].additionalRequirements.userPickupPoint.address`}
              label={messages.pickupPoint}
              isRequired
            />
          )}
        </div>
      )}
      <div className='form-row'>
        {includedFood && (
          <FormInput
            name={`trips[0].additionalRequirements.dietaryRequirements`}
            label={messages.dietaryRequirements}
          />
        )}
        <FormInput
          name={`trips[0].additionalRequirements.otherRequirements`}
          label={messages.otherRequirements}
        />
      </div>
    </div>
  )
}

export default AdditionalInfo
